/* tslint:disable */
/* eslint-disable */
/**
 * OAuth_2.0 API
 * The API is reachable from public networks, the caller can be authenticated either by an OAuth2 Access Token (for web and mobile) or an API key (for in-house services).
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface AuthCodeRequestCamApp
 */
export interface AuthCodeRequestCamApp {
    /**
     * The application client id on behalf of which the code is requested
     * @type {string}
     * @memberof AuthCodeRequestCamApp
     */
    client_id: AuthCodeRequestCamAppClientIdEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum AuthCodeRequestCamAppClientIdEnum {
    JasminCam5 = 'jasmin-cam-5',
    OranumCam5 = 'oranum-cam-5',
}
